import RendererEditor from './RendererEditor';

export default RendererEditor;
